// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ManageStorage = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M68.706 66.467a2 2 0 0 1-2 2H29.291a2 2 0 0 1 0-4h37.415a2 2 0 0 1 2 2ZM56.638 28.224v-4.102a2.1 2.1 0 1 1 4.199 0v4.102a2.1 2.1 0 1 1-4.199 0ZM83.5 83.5h-71v-71h10.061v28.405c0 5.015 4.08 9.094 9.095 9.094h32.685c5.015 0 9.095-4.079 9.095-9.094V15.327L83.5 25.39V83.5Zm-14.064-71v28.405A5.101 5.101 0 0 1 64.341 46H31.656a5.101 5.101 0 0 1-5.095-5.095V12.552c1.16-.029 2.888-.052 5.095-.052h37.78Zm17.478 10.647L72.851 9.085c-.016-.016-.036-.027-.052-.042a1.877 1.877 0 0 0-.249-.204c-.04-.027-.084-.045-.126-.069-.072-.041-.142-.084-.218-.116-.047-.02-.098-.029-.146-.045-.076-.025-.149-.054-.228-.069a1.935 1.935 0 0 0-.396-.04H10.5a2 2 0 0 0-2 2v75a2 2 0 0 0 2 2h75a2 2 0 0 0 2-2V24.561a2 2 0 0 0-.586-1.414Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default ManageStorage;
